<template>
  <div class="row justify-content-center">
    <div class="col-md-8 text-center">
      <img src="@/assets/img/404.png" alt />
      <h2>
        {{ $t("pages.notFound.title") }}
      </h2>
    </div>
  </div>
</template>

<script>
export default {};
</script>
